module.exports = __webpack_public_path__ + "static/media/india_map.963373a0.svg";